import React from 'react';

import { useCurrentLayout } from '../../components/context/layout';
import useCarouselBreakpoints from '../../hooks/use-carousel-breakpoints';
import VehicleBodyItem from './components/vehicle-body-item';
import VehicleBodyViewMore from './components/vehicle-body-viewmore';
import { withComponentHandler } from '../../hocs/with-component-handler';
import { vehicleBodySelectorPropTypes } from './constants/prop-types';

const VEHICLE_BODY_SELECTOR = 'VEHICLE_BODY_SELECTOR';

const namespace = 'ui-search-vehicle-body-selector';

/**
 * VehicleBodySelector component renders a list of vehicle body types with an optional "view more" button.
 *
 * @component
 * @param {import("./constants/prop-types").VehicleBodySelectorProps} [props] - Component props
 */
const VehicleBodySelector = (props) => {
  const currentLayout = useCurrentLayout();
  const { slidesToShow, viewMoreText } = useCarouselBreakpoints(
    VEHICLE_BODY_SELECTOR,
    currentLayout.id,
    props?.total_body_types,
  );

  if (!props?.values) {
    return null;
  }

  const { values, image, modal } = props;

  return (
    <div className={namespace}>
      <ul>
        {values
          ?.filter((_, index) => index < slidesToShow)
          .map((value) => (
            <VehicleBodyItem key={value.id} {...value} image={image} />
          ))}
        {viewMoreText && <VehicleBodyViewMore modal={modal} text={viewMoreText} />}
      </ul>
    </div>
  );
};

VehicleBodySelector.propTypes = vehicleBodySelectorPropTypes;

export default withComponentHandler(VehicleBodySelector, { componentName: 'vehicle-body-selector' });
